function orderList(object){
    object = object.sort((a, b) =>  a.fields.name > b.fields.name ? 1 : -1 );
    return object;
}

function objectifyArr(arrayParam){
    let jsonAtttempt = {};
    for (var i =0 ; i < arrayParam.length; i++){
        jsonAtttempt[arrayParam[i].id] = arrayParam[i].fields;  
    }
    return jsonAtttempt;
}

export {
    orderList,
    objectifyArr
}